<script lang="ts">
  import { onMount } from "svelte";
  import { _ as t } from "svelte-i18n";
  import { marked } from "marked";
  import DOMPurify from "dompurify";
  import { getActivityDetail, getActivityInfo } from "../lib/restful";
  import { getRule } from "../lib/rule";
  import { currentLocale } from "../i18n";
  import {
    isEmbedded as isEmbeddedDevice,
    shouldShowNavBar,
  } from "../../libs/chief-bridge";
  import { getContainerStyle } from "../../libs/layout";
  import NavBar from "../../libs/components/NavBar.svelte";
  import { bridge as closeBridge } from "../lib/bridge";
  import { LOTTERY_CODE_D3 } from "../lib/constants";
  const showNavBar = shouldShowNavBar();
  const isEmbeddedApp = isEmbeddedDevice();
  const activityCode =
    new URLSearchParams(window.location.search).get("lotteryid") ||
    LOTTERY_CODE_D3;

  let rulesHtml = $state("");
  let loading = $state(true);

  onMount(async () => {
    try {
      const res = isEmbeddedApp
        ? await getActivityDetail(activityCode)
        : await getActivityInfo(activityCode);
      if (res.data.code === 0 && res.data.data?.activityRules) {
        rulesHtml = DOMPurify.sanitize(
          marked.parse(res.data.data.activityRules, { async: false }),
        );
      } else {
        // 接口无内容时降级到本地占位规则
        rulesHtml = DOMPurify.sanitize(getRule(currentLocale));
      }
    } catch (e) {
      console.error("getActivityRules error:", e);
      // 接口失败时降级到本地占位规则
      rulesHtml = DOMPurify.sanitize(getRule(currentLocale));
    } finally {
      loading = false;
    }
  });

  function handleBack() {
    const url = new URL(window.location.href);
    url.searchParams.delete("rules");
    window.history.pushState({}, "", url);
    window.dispatchEvent(new PopStateEvent("popstate"));
    return false;
  }

  function handleClose() {
    closeBridge.callNative("Route_HomePage");
  }
</script>

<svelte:head>
  <title>{$t("activity_rules")}</title>
</svelte:head>

<NavBar
  title={$t("activity_rules")}
  scrollFade={false}
  onBack={handleBack}
  onClose={handleClose}
  class="bg-white"
>
  <div
    class="px-[16px] py-[16px] text-[14px] leading-[1.8] text-[#333] rules-content"
    style={showNavBar
      ? "padding-top: var(--nav-bar-height, 0px);"
      : "padding-top: 44px;"}
  >
    {#if !showNavBar}
      <div
        style="{getContainerStyle()} position:fixed;top:0;left:0;right:0;z-index:50;height:44px;display:flex;align-items:center;background:#fff;padding:0 16px;"
      >
        <div style="position:relative;z-index:1;min-width:24px;">
          <button
            style="width:24px;height:24px;display:flex;align-items:center;justify-content:center;background:none;border:none;padding:0;cursor:pointer;"
            onclick={handleBack}
            aria-label="返回"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 19L8 12L15 5"
                stroke="#000000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
        <div
          style="position:absolute;left:60px;right:60px;text-align:center;font-size:18px;font-weight:600;color:#000;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
        >
          {$t("activity_rules")}
        </div>
      </div>
    {/if}
    {#if loading}
      <p class="text-center text-[#999]">Loading...</p>
    {:else if rulesHtml}
      {@html rulesHtml}
    {:else}
      <p class="text-center text-[#999]">{$t("no_rules")}</p>
    {/if}
  </div>
</NavBar>

<style>
  .rules-content {
    width: 100%;
  }
  .rules-content :global(p) {
    margin: 0 0 8px;
    word-break: break-all;
  }
  .rules-content :global(h1),
  .rules-content :global(h2),
  .rules-content :global(h3) {
    margin: 16px 0 8px;
    font-weight: bold;
  }
  .rules-content :global(h1) {
    font-size: 20px;
  }
  .rules-content :global(h2) {
    font-size: 17px;
  }
  .rules-content :global(h3) {
    font-size: 15px;
  }
  .rules-content :global(ul),
  .rules-content :global(ol) {
    padding-left: 20px;
    margin: 0 0 8px;
  }
  .rules-content :global(li) {
    margin-bottom: 4px;
  }
  .rules-content :global(a) {
    color: #3e5bdb;
    text-decoration: underline;
  }
  .rules-content :global(table) {
    width: 100%;
    border-collapse: collapse;
    margin: 8px 0;
  }
  .rules-content :global(th),
  .rules-content :global(td) {
    border: 1px solid #e5e5e5;
    padding: 6px 8px;
    text-align: left;
    font-size: 13px;
  }
  .rules-content :global(th) {
    background: #f5f5f5;
    font-weight: 600;
  }
</style>
